import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository, WindowRef } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {
     Lists_loaiphieu, Lists_khohang, Lists_nhacungcap
  , Lists_sanpham
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { EmitType, detach } from '@syncfusion/ej2-base';
import { UploaderComponent, RemovingEventArgs, SelectedEventArgs, SuccessEventArgs, FileInfo } from '@syncfusion/ej2-angular-inputs';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogComponent, ButtonPropsModel, PositionDataModel, ResizeDirections } from '@syncfusion/ej2-angular-popups';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';
import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import { SelectionService, EditService, SelectionSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import { RichTextEditorComponent, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { FileManagerSettingsModel, QuickToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { FileManagerComponent, FileOpenEventArgs, FileSelectEventArgs } from '@syncfusion/ej2-angular-filemanager';


const swal = require('sweetalert');
@Component({
  selector: 'app-dieuhanh-thuchiedit',
  templateUrl: './thuchiedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./thuchiedit.component.scss'],
  providers: [ListService, Repository, WindowRef, MaskedDateTimeService, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService],
  encapsulation: ViewEncapsulation.None
})


export class thuchieditComponent implements OnInit {
  dschinhanhs: any;
  dskhohangs: any;
  dsnhacungcaps: any;
  dsloaiphieus: any;
  dsdonvitinhs: any;

  private hostUrl: string = '/';

  @ViewChild('myModal') myModal: BsModalComponent;
  @ViewChild('dteloaiphieuedit') dteloaiphieuedit: any;

   
  public ngaybatdau: Date = null;
  public ngayketthuc: Date = null;

  // Add these properties to your component class
  public danhSachPhanBo: any[] = [];
  public hasPhanBo: boolean = false;
  // Add these properties to the component class
  @ViewChild('mdKhoaHoc') mdKhoaHoc: BsModalComponent;
  public khoaHocSearchTerm: string = '';
  public danhSachKhoaHoc: any[] = [];
  public hinhThucThanhToans: any[] = [
    { Ten: 'Thanh toán hết', Id: 0 },
    { Ten: 'Đặt cọc', Id: 1 },
    { Ten: 'Thanh toán 1 phần', Id: 2 }
  ];

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputloaicauhois: any
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, LoaiPhieuId: null,
    QuyenSo: null,
    SoPhieu: null,
    DonViId: null,
    Ngay: null,
    NguoiId: null,
    HoVaTen: null,
    DiaChi: null,
    SoTien: null,
    GhiChu: null,
    PhuongThuc: null,
    DinhKem: null
    , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  inputloais: any = [{ Id: 0, Ten: 'Đúng sai' }, { Id: 1, Ten: 'Một lựa chọn' }, { Id: 2, Ten: 'Nhiều lựa chọn' }, { Id: 3, Ten: 'Tự luận' }]
  inputphuongthucs: any = [
    { Ten: 'Tiền mặt', Id: 0 },
    { Ten: 'Chuyển khoản', Id: 1 },
    { Ten: 'Quẹt thẻ', Id: 2 },
    { Ten: 'Trả góp', Id: 3 },
    { Ten: 'Không có', Id: 4 },
  ];

  inputhinhthucthanhtoans: any = [{ Id: 0, Ten: 'Thanh toán tại nhà' }, { Id: 1, Ten: 'Chuyển khoản' }]

  inputmonhocs: any;
  inputloaikhoanluongs: any = [{ Id: 1, Name: 'Thu nhập thường xuyên' }, { Id: 2, Name: 'Thu nhập không thường xuyên' }, { Id: 3, Name: 'Khấu trừ thường xuyên' }, { Id: 4, Name: 'Khấu trừ không thường xuyên' }]
  inputloaikieunhaps: any = [{ Id: 1, Name: 'Số tiền' }, { Id: 2, Name: 'Tỷ lệ (%)' }, { Id: 3, Name: 'Hệ số' }]
  inputloaikhoans: any;
  inputloaithis: any;
  inputtaikhoantaisans: any;
  inputmucdocauhois: any;
  inputtinhs: any;
  inputhuyens: any;
  inputxas: any;

  file: any;
  idnew: string;
  hienthianh: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  public ngxCurrencyOption2s = {
    prefix: '',
    thousands: '',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

  inputGiangViens: any;
  
   
  constructor(private _dataService: ListService, public repo: Repository, private sanitizer: DomSanitizer) {


  }
  transformYourHtml(htmlTextWithStyle) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
  }
  ngOnInit(): void {
    //document.getElementById('target').classList.add('upload-dialog1');
    //document.getElementById('defaultfileupload').style.display = 'none';
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngAfterViewInit() {
    //setTimeout(() => {
    //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
    //  this.rteObj.toolbarModule.refreshToolbarOverflow();
    //}, 400);
  } 



  adddata_LoaiPhieu() {    
    this.dteloaiphieuedit.loadDataInit(Lists_loaiphieu.id, null, this.doituongSelect.DonViId, this.loaiphieu, 1);
    this.myModal.open();
  }
  saveModal_LoaiPhieu(id: any) {
    if (id != null) {
      this.repo.postRequest('api/loaiphieu/GetDS_LOAIPHIEU', { DonViId: this.doituongSelect.DonViId, LoaiPhieu: this.loaiphieu })
        .subscribe(response => {
          this.dsloaiphieus = response;
          this.myModal.close();
        }); 
    
    }
    else
      this.myModal.close();
  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  public dviid: string;
  bledit: boolean = false;
  currentUser: any;
  tudanhsach: number;
  
  
  
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  public changeChiNhanh($event: any) {
    if (typeof $event === "undefined") {
      this.doituongSelect.DonViId = null;

    }
    else {
      this.doituongSelect.DonViId = $event.Id;
      this.repo.postRequest('api/loaiphieu/GetDS_LOAIPHIEU', { DonViId: this.doituongSelect.DonViId, LoaiPhieu: this.loaiphieu })
        .subscribe(response => {
          this.dsloaiphieus = response;
        });
    }
  }
 

  @ViewChild('mdKhoHang')
  mdKhoHang: BsModalComponent;
  @ViewChild('dtekhohangedit') dtekhohangedit: any;
  @ViewChild('mdNhaCungCap')
  mdNhaCungCap: BsModalComponent;
  @ViewChild('dtenhacungcapedit') dtenhacungcapedit: any;
  @ViewChild('mdSanPham')
  mdSanPham: BsModalComponent;
  @ViewChild('dtesanphamedit') dtesanphamedit: any;

  AddKhoHang() {
    this.dtekhohangedit.loadDataInit(Lists_khohang.id, null, this.currentUser.id_don_vi, null, 0);
    this.mdKhoHang.open();

  }
  saveModal_Kho(doituong: any) {
    this.mdKhoHang.close();
    this.dskhohangs.push({
      Id: doituong.Id, Ten: doituong.Ten
      , Ma: doituong.Ma
    })
    this.dskhohangs = this.dskhohangs.slice();
    this.doituongSelect.KhoHangId = doituong.Id;

  }

  AddNhaCungCap() {
    this.dtenhacungcapedit.loadDataInit(Lists_nhacungcap.id, null, this.currentUser.id_don_vi, null, 0);
    this.mdNhaCungCap.open();

  }
  saveModal_NhaCungCap(doituong: any) {
    this.mdNhaCungCap.close();
    this.dsnhacungcaps.push({
      Id: doituong.Id, Ten: doituong.Ten
      , Ma: doituong.Ma
    })
    this.dsnhacungcaps = this.dsnhacungcaps.slice();
    this.doituongSelect.NhaCungCapId = doituong.Id;

  }

  AddSanPham() {
    this.dtesanphamedit.loadDataInit(Lists_sanpham.id, null, this.currentUser.id_don_vi, null, 0);
    this.mdSanPham.open();

  }
  saveModal_SanPham(doituong: any) {
    this.mdSanPham.close();
    this.dsloaiphieus.push({
      Id: doituong.Id, Ten: doituong.Ten
      , Ma: doituong.Ma
    })
    this.dsloaiphieus = this.dsloaiphieus.slice();
    this.doituongSelect.SanPhamId = doituong.Id;
    this.doituongSelect.DonViTinhId = doituong.DonViTinhId;

  }
  tenloaiphieu: string;
  loaiphieu: number;
  loaiphieuid: string;
  tennguoinop: string;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, loaiphieuid: string, tenloaiphieu: string, loaiphieu: number,tenkhoahoc:string) {
    //this.tudanhsach = tudanhsach;
    this.loaiphieuid = loaiphieuid;
    this.tenloaiphieu = tenloaiphieu;
    this.loaiphieu = loaiphieu;

    console.log("=====================LoaiPhieu:" + loaiphieu)

    this.dviid = donviid;

    if (loaiphieu == 0 || loaiphieu == 2 )
      this.tennguoinop = "Người nộp";
    else
      this.tennguoinop = "Người chi";

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {
      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === Lists_loaiphieu.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);

    

    this.doituongSelect = {
      Id: null, LoaiPhieuId: null,
      LoaiPhieu:null,
      QuyenSo: null,
      SoPhieu: null,
      DonViId: null,
      Ngay: null,
      NgayChungTu:null,
      NguoiId: null,
      HoVaTen: null,
      DiaChi: null,
      SoTien: null,
      GhiChu: null,
      PhuongThuc: null,
      KhoaHocTen: null,
      DangKyGoiHocId:null,
      HinhThuc:null,
      DinhKem: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      
    };
    this.ngaybatdau = null;
    this.ngayketthuc = null;

    if (donviid != null)
      this.doituongSelect.DonViId = parseInt(donviid);
    else
      this.doituongSelect.DonViId = parseInt(this.currentUser.id_don_vi);

    this.doituongSelect.HeSo = 1;
    this.doituongSelect.Ngay = new Date();
    this.doituongSelect.NgayChungTu = new Date();
    this.doituongSelect.LoaiPhieuId = this.loaiphieuid;
    this.doituongSelect.LoaiPhieu = this.loaiphieu;

    this.repo.postRequest('api/loaiphieu/GetDS_LOAIPHIEU', { DonViId: this.doituongSelect.DonViId, LoaiPhieu: this.loaiphieu })
      .subscribe(response => {
        this.dsloaiphieus = response;
      }); 

    this.repo.postRequest('api/login/gettrungtam2s', { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.dschinhanhs = response;
      });
    
   

    if (id === null) {

      this.bledit = false;
      this.doituongSelect.Created = new Date();
      this.doituongSelect.Modified = new Date();
      if (this.currentUser !== null) {
        this.doituongSelect.CreatedBy = this.currentUser.user_name;
        this.doituongSelect.ModifiedBy = this.currentUser.user_name;

      }
      this.danhSachPhanBo = [];
      //this.doituongSelect.PhuongThuc = 0;

      this.repo.postRequest('api/quanlythuchi/get_maphieu', { DonViId: this.doituongSelect.DonViId, LoaiPhieu: this.loaiphieu })
        .subscribe(response => {
          this.doituongSelect.SoPhieu = response;
        });

      //setTimeout(() => {
      //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
      //  this.rteObj.toolbarModule.refreshToolbarOverflow();
      //}, 400);


      //this.repo.postRequest("api/khoahoc/getnoidungthanhtoan/", { Id: this.khoahocid })
      //  .subscribe(response => {
      //    if (response !== null)
      //      this.doituongSelect.NoiDungChuyenKhoan = response[0].NoiDungChuyenKhoan;
      //  });
      this.loadPhanBoData();

    }
    else {
      this.bledit = true;
      console.log("t11");
      this.repo.getRequest("api/quanlythuchi/getmodel/" + id)
        .subscribe(response => {
          this.doituongSelect.Id = id;

          this.doituongSelect.LoaiPhieuId = response.LoaiPhieuId;
          this.doituongSelect.QuyenSo = response.QuyenSo;
          this.doituongSelect.SoPhieu = response.SoPhieu;
          this.doituongSelect.LoaiPhieu = this.loaiphieu;
          this.doituongSelect.DonViId = response.DonViId;
          this.doituongSelect.KhoaHocTen = tenkhoahoc;
          this.doituongSelect.DangKyGoiHocId = response.DangKyGoiHocId;
          this.doituongSelect.HinhThuc = response.HinhThuc;
          if (response.Ngay != null)
            this.doituongSelect.Ngay = new Date(response.Ngay);
          if (response.NgayChungTu != null)
            this.doituongSelect.NgayChungTu = new Date(response.NgayChungTu);
          this.doituongSelect.NguoiId = response.NguoiId;
          this.doituongSelect.HoVaTen = response.HoVaTen;
          this.doituongSelect.DiaChi = response.DiaChi;
          this.doituongSelect.SoTien = response.SoTien;
          this.doituongSelect.GhiChu = response.GhiChu;
          this.doituongSelect.PhuongThuc = response.PhuongThuc;
          this.doituongSelect.DinhKem = response.DinhKem;

                  
          
          this.doituongSelect.Created = new Date(response.Created);
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;

          //setTimeout(() => {
          //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
          //  this.rteObj.toolbarModule.refreshToolbarOverflow();
          //}, 400);
          this.loadPhanBoData();
        });
      // Add this line to load allocation data
     
    }

  

  }
  // Method to clear the selected course
  public xoaKhoaHoc(): void {
    
    this.doituongSelect.DangKyGoiHocId = null;
    this.doituongSelect.KhoaHocTen = null;
  }
  Tai_Anh() {

    this.doituongSelect.XoaAnh = 1;
    $("#File").click();
  }
  Xoa_Anh() {

    this.doituongSelect.XoaAnh = 0;
    $('#preview').attr('src', "/assets/img/anhdt.gif");
  }
  getFiles(event) {
    console.log("tt");
    //console.log(event);
    this.file = event.target.files;
    if (!this.file[0].type.match("image.*")) {
      alert("Tệp chọn không phải kiểu ảnh.");
      event.srcElement.value = null;
      return;
    }

    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(this.file[0]);

  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.doituongSelect.AnhString = btoa(binaryString);  // Converting binary string data.

    $('#preview').attr('src', "data:image/png;base64," + this.doituongSelect.AnhString + "");

  }
  //  keyTenPress(event: any) { 
  //      if (event.which === 13) {
  //        this.slLoaiKhoanLuong.focus();
  //          event.preventDefault();
  //        }
  //}

  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    //if (this.doituongSelect.Id == null)
    //  this.doituongSelect.Id = 0;
    if (this.doituongSelect.DonViId == null) {
      swal('Lỗi!', 'Vui lòng chi nhánh!.', 'error');
      return;
    }
    
    if (this.doituongSelect.HoVaTen == null && this.loaiphieu==1) {
      swal('Lỗi!', 'Vui lòng nhập người chi!.', 'error');
      return;
    }
    if (this.doituongSelect.HoVaTen == null && this.loaiphieu == 0) {
      swal('Lỗi!', 'Vui lòng nhập người nộp!.', 'error');
      return;
    }
    if (this.doituongSelect.Ngay == null) {
      swal('Lỗi!', 'Vui lòng nhập ngày!.', 'error');
      return;
    }
    if (this.doituongSelect.SoTien == null) {
      swal('Lỗi!', 'Vui lòng nhập số tiền!.', 'error');
      return;
    }
    if (this.doituongSelect.PhuongThuc == null) {
      swal('Lỗi!', 'Vui lòng nhập phương thức!.', 'error');
      return;
    }
   
    
    //if (this.doituongSelect.Ten == null || this.doituongSelect.Ten == "") {
    //  swal('Lỗi!', 'Vui lòng nhập tên tham số!.', 'error');
    //  return;
    //}
    
    console.log(this.doituongSelect);
    $('#loading').show();
    this.repo.postRequest("api/quanlythuchi/addorupdate", this.doituongSelect)
      .subscribe(response => {
        $('#loading').hide();
        console.log(response);
        if (response.success == true) {
          this.doituongSelect.Id = response.data;
          this.save.emit(this.doituongSelect);
        }
        else
          swal('Cảnh báo!', response.message, 'warning');

      });
  }
  // Add this method to fetch allocation data
  loadPhanBoData(): void {
   
    if (!this.doituongSelect || !this.doituongSelect.Id ) {
      this.hasPhanBo = false;
      this.danhSachPhanBo = [];
      return;
    }

    this.repo.postRequest('api/quanlythuchi/get_phanbo/', { IdGuid: this.doituongSelect.Id })
      .subscribe(
        response => {
          if (response && Array.isArray(response) && response.length > 0) {
            this.danhSachPhanBo = response;
            this.hasPhanBo = true;
          } else {
            this.danhSachPhanBo = [];
            this.hasPhanBo = false;
          }
        },
        error => {
          console.error('Error loading allocation data:', error);
          this.danhSachPhanBo = [];
          this.hasPhanBo = false;
        }
      );
  }

  // Add this method to calculate the total allocation amount
  getTongTienPhanBo(): number {
    return this.danhSachPhanBo.reduce((total, item) => total + parseFloat(item.SoTien), 0);
  }

  // Add this method to delete allocation data
  xoaChiPhiPhanBo(): void {
    if (!this.doituongSelect || !this.doituongSelect.Id) {
      return;
    }

    swal({
      title: 'Xác nhận xóa phân bổ?',
      text: 'Bạn có chắc chắn muốn xóa toàn bộ dữ liệu phân bổ chi phí?',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest('api/quanlythuchi/delete_phanbo/', { IdGuid: this.doituongSelect.Id })
            .subscribe(
              response => {
                if (response === 'OK') {
                  swal('Thành công!', 'Đã xóa dữ liệu phân bổ chi phí.', 'success');
                  this.danhSachPhanBo = [];
                  this.hasPhanBo = false;
                } else {
                  swal('Lỗi!', response, 'error');
                }
              },
              error => {
                console.error('Error deleting allocation data:', error);
                swal('Lỗi!', 'Có lỗi xảy ra khi xóa dữ liệu phân bổ.', 'error');
              }
            );
        }
      });
  }

  // Method to open the course selection modal
  public openKhoaHocModal() {
    this.loadDanhSachKhoaHoc();
    this.mdKhoaHoc.open();
  }

  // Method to load course list
  private loadDanhSachKhoaHoc() {
    this.danhSachKhoaHoc = [];
    if (!this.doituongSelect.DonViId) {
      return;
    }

    const params = {
      donviid: this.doituongSelect.DonViId,
      username: this.currentUser.user_name
    };

    this.repo.postRequest('api/quanlythuchi/get_dangky_chuathanhtoan/', params)
      .subscribe(response => {
        console.log(response);
        if (response && Array.isArray(response)) {
          this.danhSachKhoaHoc = response;
        }
      }, error => {
        console.error('Error loading courses:', error);
      });
  }

  // Method to search courses
  public searchKhoaHoc() {
    if (!this.khoaHocSearchTerm || this.khoaHocSearchTerm.trim() === '') {
      this.loadDanhSachKhoaHoc();
      return;
    }

    const term = this.khoaHocSearchTerm.toLowerCase();

    this.danhSachKhoaHoc = this.danhSachKhoaHoc.filter(item =>
      item.TenKhoaHocS?.toLowerCase().includes(term) ||
      item.HoVaTenS?.toLowerCase().includes(term) 
    );
  }

  // Method to select a course
  public chonKhoaHoc(item: any) {
    if (!item) return;

    this.doituongSelect.DangKyGoiHocId = item.Id;   
    this.doituongSelect.KhoaHocTen = item.TenKhoaHoc;
    this.mdKhoaHoc.close();
  }
}

